<template>
  <v-content class="login-bg">
    <v-container fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <transition name="page" mode="out-in">
            <router-view/>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      color="error"
      :timeout="0"
      :bottom="true"
      v-model="error"
    >
      {{ _error }}
      <v-btn flat icon @click.native="error = ''">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'layout',
  computed: {
    error: {
      get () {
        return !!this._error
      },
      set (v) {
        this._setError(v)
      }
    },
    ...mapGetters('auth', {
      _error: 'error'
    })
  },
  methods: {
    ...mapActions('auth', {
      _setError: 'setError'
    })
  }
}
</script>

<style scoped>
  .login-bg {
    background: #C9D6FF; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #E2E2E2, #C9D6FF); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #E2E2E2, #C9D6FF); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }

  .page-enter-active, .page-leave-active {
    transition: opacity 0.2s, transform 0.2s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
    transform: scale(0);
  }
</style>
